import { ColumnType } from 'antd/es/table'
import dayjs from 'dayjs'

import { GetConsultationListResponseItem } from 'src/api/requests'
import { ConsultationStatusTag } from 'src/components/AppointmentCard/ConsultationStatusTag'
import { dayMonthYearHourMinutesFormatWithDot } from 'src/libs'
import { useLocales } from 'src/locales'

export const useColumns = () => {
  const { t } = useLocales()

  const columns: ColumnType<GetConsultationListResponseItem>[] = [
    {
      key: 'datetime',
      title: t('appointments.date_and_time'),
      render: (_, { consultationDate }) =>
        dayjs(consultationDate).format(dayMonthYearHourMinutesFormatWithDot)
    },
    {
      key: 'consultation type',
      title: t('consultations.consultation_type'),
      render: (_, { consultationType }) =>
        t(`consultation_form.type.${consultationType}`)
    },
    {
      key: 'last name',
      dataIndex: ['person', 'lastName'],
      title: t('form.last_name')
    },
    {
      key: 'first name',
      dataIndex: ['person', 'firstName'],
      title: t('form.first_name')
    },
    {
      key: 'institution',
      title: t('common.institution'),
      dataIndex: ['legalEntity', 'name']
    },
    {
      key: 'status',
      title: t('analysis.status'),
      render: (_, { status }) => <ConsultationStatusTag status={status} />
    }
  ]

  return { columns }
}
